import { setTitle } from "@/effects";
import { MarketplaceDashboardList } from "@/marketplace/MarketplaceDashboardList";
import { ProfileAreaLayout } from "@/pages/profile-area-layout";
import { pageProfiles, startsWithExtraPath } from "@/route";
import { t } from "@lingui/core/macro";
import { useFlag } from "@openfeature/react-sdk";
import { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";

type MarketplacePageProps = {
  showCustomLogo?: boolean;
};

export default function MarketplacePage({ showCustomLogo }: MarketplacePageProps) {
  const { value: isMarketplaceEnabled } = useFlag("marketplace", false);
  const location = useLocation();
  const routePrefix = startsWithExtraPath(location.pathname);

  useEffect(() => {
    setTitle(t({ id: "marketplace.title", message: "Marketplace" }));
  }, []);

  if (!isMarketplaceEnabled) {
    return <Redirect to={`${routePrefix}${pageProfiles.asString()}`} />;
  }

  return (
    <ProfileAreaLayout activeTab="marketplace" showCustomLogo={showCustomLogo}>
      <MarketplaceDashboardList />
    </ProfileAreaLayout>
  );
}
